import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useValidatePlayerData = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (request: Types.IValidatePlayerDataRequestData) => {
        const { data } = await send<Types.IValidatePlayerDataSendRequestData, Types.IValidatePlayerDataResponseData>({
            ID: 36010,
            errorLevel: 1,
            responses: [36011, 36012],
            description: 'Validate Player Data',
            casino: request.casinoName || casinoName,
            ...request
        });

        return data;
    }, [send, casinoName]);
};
